import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import LandingForm from "./LandingForm";

function Landing({
  user,
  landingPageContent,
  setLandingPageContent,
  openingHours,
  setOpeningHours,
}) {
  const [editLandingPageOpen, setEditLandingPageOpen] = useState(false);
  const workingDays = process.env.REACT_APP_WORKING_DAYS.split(",");

  const formatOpeningHours = (dayHours) => {
    const [start1, end1, start2, end2] = dayHours;

    const periods = [];

    if (start1 && end1) {
      periods.push(`${start1} à ${end1}`);
    }

    if (start2 && end2) {
      periods.push(`${start2} à ${end2}`);
    }

    return periods.length > 0 ? periods.join(" et ") : "Fermé";
  };

  return (
    <Box sx={{ p: 2, maxWidth: "sm", margin: "0 auto" }}>
      <Stack direction="column" spacing={2}>
        {landingPageContent.map((section, index) => (
          <Box key={index}>
            <Typography variant="h4" sx={{ textAlign: "center" }}>
              {section.title}
            </Typography>
            <Typography variant="body1" sx={{ textAlign: "justify" }}>
              {section.text}
            </Typography>
          </Box>
        ))}
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Maraîchage nordique
        </Typography>
        <video
          controls
          width="100%"
          style={{ border: 0, borderRadius: 8 }}
          src={process.env.REACT_APP_FARM_VIDEO_URL}
        />
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Hymne le bon sens paysan
        </Typography>
        <iframe
          width="100%"
          height="315"
          style={{ border: 0, borderRadius: 8 }}
          src="https://www.youtube.com/embed/OY2D8dUK1zs?si=cbNgQEKnYueW9ZEw"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Où sommes nous?
        </Typography>
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          Nous somme situés au 3370 Rte 138 O, Sept-Îles, QC G4R 4K1
        </Typography>
        <Box sx={{ maxWidth: "sm" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1545.5347839566273!2d-66.50047393655494!3d50.24833437677312!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4c91e19b8c0417c5%3A0x5766249919e14e81!2s3370%20Rte%20138%20O%2C%20Sept-%C3%8Eles%2C%20QC%20G4R%204K1!5e1!3m2!1sen!2sca!4v1788011053636!5m2!1sen!2sca"
            width="100%"
            height="450"
            style={{ border: 0, borderRadius: 8 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </Box>
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Nos heures d'ouverture
        </Typography>
        {openingHours["Lundi"] &&
          workingDays.map((day) => (
            <Typography>
              <strong>{day} :</strong> {formatOpeningHours(openingHours[day])}
            </Typography>
          ))}
        {user && user.accountIsAdmin === 1 && (
          <Button
            variant="contained"
            onClick={() => setEditLandingPageOpen(true)}
            width="100%"
          >
            Modifier l'accueil
          </Button>
        )}
      </Stack>

      <LandingForm
        landingPageContent={landingPageContent}
        setLandingPageContent={setLandingPageContent}
        openingHours={openingHours}
        setOpeningHours={setOpeningHours}
        workingDays={workingDays}
        open={editLandingPageOpen}
        setOpen={setEditLandingPageOpen}
      />
    </Box>
  );
}

export default Landing;
